import gbaAdminExtra from './gbaAdminExtra';

export default {
  "home": "首页",
  "btn_detail": "详情",
  "follow": "优先关注",
  "degree": "中",
  "please_placeholder": "请选择",
  "search_placeholder": "搜索客户",
  "no_data": "暂无数据",
  "persona": "360画像",
  "activity": "学术动态",
  "perception": "观念动态",
  "more_detail": "更多详情",
  "no_more_data": "暂无更多数据",
  "relationship": "合作动态",
  "persona_tag": "画像标签",
  "assessment": "评估",
  "good_at": "擅长",
  "brief": "简介",
  "network_dynamics": "网络动态",
  "all_business_cooper": "同类产品合作",
  "contact_preference": "客户互动趋势图",
  "top_channel": "TOP渠道",
  "top_content": "TOP内容",
  "perception_tag": "观念标签",
  "typing_history": "分型历史",
  "every_typing": "诊疗观念",
  "unaccredited": "未认可",
  "accredited": "认可",
  "communication_style": "沟通风格",
  "relaxion_network": "学术合作关系",
  "no_relaxion_network": "暂无学术合作数据",
  "show_relaxion_count": "显示数量：",
  "activity_tag": "学术标签",
  "activity_summary": "学术成果汇总",
  "top_activity_key": "TOP论文关键词",
  "activity_article_detail": "学术动态详情",
  "publication": "论文发表",
  "professional": "临床试验",
  "project": "国自然基金",
  "award": "获奖",
  "edit_error": "纠错",
  "first_author": "第一作者",
  "not_yet": "暂无",
  "schedules_time": "出诊时间",
  "feedback_title": "请填写您的反馈",
  "btn_cancel": "取消",
  "btn_prev": "上一步",
  "btn_sure": "确认",
  "old_age": "老年高危",
  "old_age_standard": "老年标危",
  "middle_aged": "中青年高危",
  "middle_aged_standard": "中青年标危",
  "login_txt": "登录",
  "input_name": "请输入姓名",
  "input_uid": "请输入员工ID",
  "poc_version": "当前版本为POC阶段内部测试版本",
  "poc_version_desc": "使用您的姓名和员工ID（6位或8位数字）登录",
  "login_btn": "登录",
  "show_customers_txt": "仅展示项目覆盖的重点客户。",
  "dosing_status": "进院状态",
  "clinical_trial": "科室临床试验",
  "takeda_speaker": "讲者",
  "job_details": "任职详情",
  "job_details_txt": "学/协会任职",
  "all_time": "全部",
  "one_year": "一年内",
  "five_year": "五年内",
  "publication_detail": "论文详情",
  "publication_title": "论文",
  "key_word": "关键词",
  "organization": "参加机构",
  "scope": "试验范围",
  "period": "试验分期",
  "category": "试验分类",
  "study_objectives": "试验目标",
  "applier_name": "申请者",
  "indication": "适应症",
  "drug_type": "药物类型",
  "drug_name": "药物名",
  "registration_date": "注册日期",
  "applier_status": "状态",
  "applier_contact": "申请联系人",
  "professional_subject": "试验题目",
  "abstract": "摘要",
  "authors": "作者",
  "doi": "DOI",
  "journal_if": "期刊IF",
  "journal": "发表期刊",
  "source": "来源",
  "publication_time": "发表时间",
  "thesis_title": "论文标题",
  "clinical_trial_detail": "临床试验详情",
  "clinical_trial_title": "临床试验",
  "wechat_title": "微信",
  "common_product_detail": "同类产品合作详情",
  "common_relaxion_detail": "学术合作详情",
  "publication_paper": "论文共著",
  "joint_test": "共同试验",
  "same_college": "同院校",
  "same_hospital": "同医院",
  "click_to_look": "点击医生名或连线查看合作详情",
  "click_show_more": "点击显示更多动态",
  "wechat_count": "公众号",
  "websit": "网站",
  "combination": "联合用药:",
  "public_volume": "公开文献中提及声量：",
  "high": "高",
  "medium": "中",
  "low": "低",
  "cancel_txt": "取消",
  "confirm_txt": "确定",
  "no_more_txt": "没有更多了",
  "loading_txt": "加载中...",
  "content_module": "内容板块：",
  "data_from": "数据来源：",
  "like_this": "我喜欢这功能",
  "no_like_this": "我不喜欢这功能",
  "one_proposal": "我有一个建议",
  "one_error": "我要纠错",
  "choose_feed_type": "请选择反馈类型",
  "submit_sucess": "提交成功",
  "submit_fail": "提交失败,请重新提交",
  "common_clinical_trial": "同科室临床试验",
  "feedback_data_bai": "百度学术 / 中国临床试验注册中心 / 药物临床试验登记与信息公示平台 / clinicaltrials.gov / MM领域主要微信公众号及论坛网站",
  "feedback_data_hao": "百度学术 / 中国临床试验注册中心 / 药物临床试验登记与信息公示平台 / clinicaltrials.gov / 好大夫在线",
  "feedback_data_takeda": "武田内部数据",
  "feedback_data_mm": "MM领域主要微信公众号及论坛网站",
  "feedback_data_hao_online": "好大夫在线",
  "feedback_data_gov": "百度学术 / 中国临床试验注册中心 / 药物临床试验登记与信息公示平台 / clinicaltrials.gov",
  "feedback_data_hao_gov": "百度学术 / 中国临床试验注册中心 / 药物临床试验登记与信息公示平台 / clinicaltrials.gov / 国家自然科学基金 / 好大夫在线",
  "feedback_data_gov_ling": "中国临床试验注册中心 / 药物临床试验登记与信息公示平台 / clinicaltrials.gov",
  "show_more_txt": "点击显示更多",
  "job_list": "任职列表",
  "yes": "是",
  "no": "否",
  "dosing_product": "计划名称",
  "dosing_listing_type": "列院类型",
  "dosing_over": "已完成",
  "dosing_no_over": "未完成",
  "month": "月",
  "choose_relation_type": "选择关系类型：",
  "is_mm": "是否MM：",
  "all_type": "全部类型",
  "filter_publication": "学术动态筛选条件",
  "filter_type": "类型：",
  "filter_is_mm": "是否MM领域：",
  "filter_author": "作者类型：",
  "filter_if": "期刊IF：",
  "hcp_barrier_txt": "注：只要专家没有对该观念完全认可，都视为“未完全认可”",
  "select_filter_condition": "选择筛选条件",
  "info_from_external": "信息来源于外部公开数据，实际出诊信息请以官网公布为准。",
  "info_from_open": "信息来源于外部公开数据，仅供参考。",
  "follow_name": "关注客户",
  "search_info": "信息检索",
  "search_info_details": "客户建议详情",
  "search_doctor": "搜索客户",
  "search_follow_doctor": "搜索关注客户",
  "is_top": "置顶",
  "is_top_success": "置顶成功",
  "is_top_fail": "取消置顶成功",
  "add_follow": "添加关注客户",
  "choose_follow_txt": "选择您要关注的客户，点击右侧的",
  "choose_follow_btn": "按钮",
  "recommend": "推荐",
  "follow_txt": "关注",
  "doctor_details": "客户详情",
  "barrier_customer": "客户的该核心障碍",
  "barrier_is_solve": "是否已解决？",
  "change_barrier_title": "更换核心障碍",
  "aim_picture": "目标行为路径图",
  "current_behavior": "当前行为",
  "behavior_dangerous": "预后评估及危险分层",
  "behavior_programme": "常规治疗方案选择",
  "behavior_treatment": "随访检测及治疗评估",
  "behavior_time": "方案调整时机",
  "behavior_now": "当前行为：",
  "behavior_pathient": "患者管理",
  "communication_suggestions": "沟通建议",
  "hide_more": "隐藏更多",
  "no_more_suggest": "对于客户当前目标行为已无更多建议。",
  "no_more_suggest_update": "请评估客户的分型与行为是否需要更新。<br />\r\n也可以前往信息检索寻找合适的建议。",
  "no_more_suggest_if": "如果问题还未解决，",
  "no_more_suggest_help": "可以向您的经理请求辅导 ",
  "communication_style_txt": "客户沟通风格",
  "communication_style_disc": "客户沟通风格（DISC分型）：",
  "communication_style_btn": "请填写客户沟通风格",
  "is_adopt": "已于1月4日采纳该建议",
  "click_show_more_filter": "点击显示更多筛选条件",
  "click_hide_more_filter": "隐藏更多筛选条件",
  "patient_type_screening": "根据希望沟通的患者情况检索",
  "patient_type_age": "选择患者年龄段",
  "patient_type_dangerous": "选择患者危险等级",
  "patient_type_body": "选择患者体质",
  "patient_type_type": "选择患者治疗阶段",
  "patient_type_disease": "选择患者病程",
  "patient_type_filter": "根据希望解决的核心障碍检索",
  "suggest_patient_type": "患者类型",
  "suggest_patient_solve": "建议解决",
  "suggest_patient_barrier_content": "核心障碍",
  "suggest_patient_physician_challenge": "困难点",
  "suggest_patient_physician_action": "采取行动",
  "suggest_patient_transmit": "建议传递",
  "suggest_patient_key_message": "关键信息",
  "suggest_patient_aim": "建议目标行为",
  "suggest_patient_content_title": "建议使用资料",
  "suggest_patient_content_none": "无建议使用资料",
  "suggest_patient_communicate": "建议沟通方式",
  "suggest_patient_like": "要",
  "suggest_patient_unlike": "不要",
  "suggest_key_info": "建议的关键信息",
  "suggest_key_find": "找到",
  "suggest_key_fit": "条适合的关键信息",
  "tips_title": "温馨提示",
  "no_next_suggest": "暂无下一条建议",
  "make_sure_next": "请确认是否更换为下一个",
  "key_message": "关键信息",
  "use_content": "使用资料",
  "make_sure_follow": "确定取消关注吗?",
  "go_hcp": "前往查看客户360画像，是否继续？",
  "has_aim_to": "已达到目标行为，请重新评估客户分型",
  "answer_qust": "请回答以下两个问题来给专家分型：",
  "info_is_update": "信息已更新，建议重新计算中...",
  "send_sucess": "推送成功",
  "send_fail": "推送失败",
  "make_sure_send": "请确认是否向",
  "make_sure_send1": "发送吾医空间推文《",
  "make_sure_send2": "》？",
  "visit_feedback": "拜访反馈",
  "customer_barrier": "客户核心障碍",
  "select_reason": "请选择不接受该建议的理由",
  "behavior_stage": "行为阶段",
  "current_behavior_stage": "当前行为阶段",
  "has_arrow": "已于",
  "has_month": "月",
  "has_day": "日",
  "has_day_advice": "采纳该建议",
  "has_day_accept": "接受辅导",
  "has_day_over": "完成辅导",
  "has_visited": "已拜访",
  "barrier_progress": "核心障碍转化完成度",
  "barrier_keyinfo_feddback": "客户对于关键信息反馈",
  "barrier_familiar": "客户对于材料熟悉程度",
  "barrier_assessment": "请对客户的核心障碍认可程度进行评估：",
  "agreen_no": "不接受",
  "agreen_ok": "完全接受",
  "agreen_no_approval": "未完全认可",
  "agreen_approval": "完全认可",
  "agreen_no_follow_up": "不跟进",
  "agreen_follow_up": "跟进",
  "tips_typing": "请回答问题来给专家分型",
  "tips_typing_error": "专家分型失败，请重新答题",
  "tips_style_error": "沟通风格提交失败",
  "tips_answer_must": "请先回答问题",
  "tips_feedback_error": "反馈失败",
  "tips_thanks": "感谢采纳！",
  "tips_segment": "请确认该客户分型",
  "tips_behavior": "请确认该客户当前行为",
  "tips_communicationstyle": "请确认该客户沟通风格",
  "slove_difficulty": "解决当前核心障碍时遇到困难，",
  "slove_help": "已向您的经理发送求助。",
  "hcp_visit_list_covisit_tab": "协访",
  "hcp_visit_list_create_visit": "新建拜访",
  "hcp_visit_list_create_covisit": "新建协访",
  "hcp_visit_list_draft_banner": "当前有 {count} 条{type}草稿未提交，建议尽快补充并提交。",
  "hcp_visit_draft_tag": "草稿",
  "hcp_visit_diner_tag": "餐费",
  "hcp_visit_companion_label": "同行人：",
  "hcp_visit_unselected_physician": "未选择医生",
  "hcp_visit_feedback_count": "{count} 反馈",
  "hcp_visit_delete_draft_action": "删除草稿",
  "hcp_visit_draft_dialog_title": "提示",
  "hcp_visit_draft_auto_saved_confirm_back": "当前内容未提交，但已自动保存为草稿，是否确认返回？",
  "hcp_visit_delete_draft_confirm": "是否删除当前草稿？",
  "hcp_visit_draft_deleted": "草稿已删除",
  "current_customer_txt": "基于当前客户的",
  "current_customer_style": "沟通风格，沟通过程中注意：",
  "will_doing": "待处理",
  "already_confirm": "已确认",
  "already_refuse": "已拒绝",
  "already_make_true": "待确认",
  "question_txt": "（对于分型的更新将会提交给经理进行确认）",
  "question_choose_pi": "客户认为患者的持续治疗是有必要的吗？客户会为了实现患者更深的缓解而选择PI进行持续治疗吗？",
  "question_pi_percent": "(PI的持续治疗比例为40%，低于40%认定为否)",
  "question_v_based": "对于初次使用V-based方案，为了实现患者的长期获益，你会在4个月内转换I-based方案吗？",
  "question_v_i": "(30%V转I，认定为是)",
  "no_follow_doctor": "您尚未添加关注客户",
  "no_follow_doctor_desc": "请在这里添加您最想要关注的客户",
  "coaching_completed": "已完成辅导",
  "btn_feedback": "填写反馈",
  "btn_next": "下一个",
  "btn_change": "更换",
  "btn_plan_visit": "计划拜访",
  "btn_update": "更新",
  "btn_article": "推送文章",
  "btn_submit": "提交",
  "btn_edit": "修改",
  "btn_add_barrier": "填写核心障碍",
  "btn_is_solve": "已解决",
  "btn_no_solve": "未解决，需要辅导",
  "btn_change_solve": "未解决，换一个",
  "btn_change_one": "换一个核心障碍",
  "btn_give_up_follow": "放弃关注",
  "btn_make_sure_follow": "确认并关注",
  "btn_go_hcp": "前往画像",
  "btn_need_help": "待辅导",
  "btn_make_perception": "待确认分型",
  "btn_make_behavior": "待确认当前行为",
  "btn_confirm": "确认",
  "btn_refuse": "拒绝",
  "btn_close": "关闭",
  "btn_communication_style": "待确认沟通风格",
  "task_quarter_progress": "本季度推广进度",
  "task_view_detail": "查看详情",
  "task_quarter_deadline": "季度截止：",
  "task_completed_forward": "已完成转发",
  "task_target_forward": "本季度目标转发",
  "task_view_all_articles": "查看全部文章",
  "task_filter_product": "筛选产品",
  "task_filter_task": "筛选任务",
  "task_no_more_task": "没有更多任务了",
  "task_all_task": "所有任务",
  "task_all_product": "所有产品",
  "task_executed_task": "已执行的任务",
  "task_ignored_task": "已忽略的任务",
  "task_type_task": "任务",
  "task_deadline": "截止时间：",
  "task_meeting_time": "会议时间：",
  "task_preview": "预览",
  "task_recommend_reason": "推荐理由：",
  "task_target_doctor": "目标医生",
  "task_target_doctor_suffix": "目标医生",
  "task_star_indicate": "标★表示",
  "task_priority_recommend": "优先推荐",
  "task_executed": "已执行",
  "task_ignored": "已忽略",
  "task_invite": "邀请",
  "task_send": "发送",
  "task_visit": "拜访",
  "task_fill": "填报",
  "task_modify": "修改",
  "task_reinvite": "再邀请",
  "task_resend": "再发送",
  "task_interaction_detail": "互动详情",
  "task_browse": "浏览",
  "task_no_interaction": "暂无互动记录",
  "task_ignore_success": "任务已忽略",
  "task_confirm_operation": "确认操作",
  "task_confirm_ignore": "确定要忽略该任务吗？",
  "task_ignore_fail": "忽略任务失败，请稍后再试",
  "task_execute_success": "任务已执行",
  "task_execute_fail": "任务执行失败，请稍后再试",
  "task_resend_success": "任务已重新发送",
  "task_resend_fail": "重新发送任务失败，请稍后再试",
  "task_send_fail": "发送内容失败，请稍后再试",
  "task_forward_fail": "转发失败，请稍后重试",
  "task_suggest_wording": "建议话术",
  "task_copy_wording": "复制话术",
  "task_skip": "跳过",
  "task_copy_fail": "复制失败",
  "task_content_preview": "内容预览",
  "task_live": "直播",
  "task_survey": "问卷",
  "task_doctor_survey": "医生问卷",
  "task_tweet": "推文",
  "task_other": "其他",
  "task_execution_detail": "任务执行详情",
  "task_data_overview": "数据概览",
  "task_quarter_send": "本季度发送",
  "task_quarter_open": "本季度打开",
  "task_kpi_updated_yesterday": "统计数据截止昨日",
  "task_times": "次",
  "task_open": "打开",
  "task_month": "月",
  "ai_assistant": "AI助手",
  "ai_thinking": "思考中",
  "ai_thinking_context": "翻翻上下文",
  "ai_thinking_lookup": "找找关键线索",
  "ai_thinking_answer": "把答案捋顺",
  "ai_thinking_default": "立即",
  "ai_thinking_toggle": "思考",
  "ai_thought_process": "思考过程",
  "ai_thought_seconds": "思考用时 {seconds} 秒",
  "history_title": "历史会话",
  "no_history": "暂无历史记录",
  "suggestions_and_inquiries": "建议与问询",
  "next_visit_suggestion": "下一步该拜访谁",
  "vyepti_advantage": "Vyepti的核心优势是什么",
  "xx_updates": "XX老师最近有什么动态",
  "visit_prep": "今天和XX老师的拜访该怎么准备",
  "placeholder_ai_assistant": "AI 助手",
  "placeholder_smart_qa": "智能问答",
  "placeholder_ai_visit": "AI 记拜访",
  "placeholder_ai_suggestion": "AI 建议",
  "prompt_delete_session": "确定要删除这条会话记录吗？",
  "prompt_delete_success": "删除成功",
  "prompt_delete_fail": "删除失败",
  "prompt_hint": "提示",
  "kpi_completion": "KPI完成情况",
  "kpi_detail_entry_title": "查看KPI指标明细",
  "kpi_detail_entry_desc": "展示当前可从系统获取的过程指标",
  "kpi_tap_to_view": "点击查看详细指标",
  "target_achievement_rate": "目标达成率",
  "recent_updates": "近期动态",
  "no_recent_updates": "暂无近期动态",
  "week_task": "当前任务",
  "total_task": "总任务",
  "completed_task": "已完成",
  "go_to_complete": "去完成",
  "task_more_doctors": "等{count}位",
  "highest_priority": "最高优先级",
  "loading_tasks_text": "加载任务中...",
  "task_type_conference": "直播",
  "task_type_survey": "问卷",
  "task_type_hcp_survey": "医生问卷",
  "task_type_visit": "拜访",
  "task_type_content": "推文",
  "task_type_call": "拜访",
  "task_type_segment": "问卷",
  "task_type_other": "其他",
  "plan_visit": "计划拜访",
  "send": "发送",
  "send_content": "发送内容",
  "recommended_content": "推荐内容",
  "select_approved_content": "选择系统内已审批内容",
  "go_to_all_tasks": "前往当前任务",
  "loading": "加载中...",
  "sending": "发送中...",
  "recommended_wording": "建议话术",
  "copy_wording": "复制话术",
  "skip": "跳过",
  "copy_failed": "复制失败",
  "task_resent": "任务已重新发送",
  "re_send_failed": "重新发送任务失败，请稍后再试",
  "send_content_failed": "发送内容失败，请稍后再试",
  "get_content_failed": "获取内容失败",
  "forward_failed": "转发失败，请稍后重试",
  "no_preview_content": "暂无可预览内容",
  "btn_save": "保存",
  "visit_info": "拜访信息",
  "expense_info": "餐费信息",
  "select_key_message": "选择关键信息",
  "brintellix_strategy_map": "Brintellix 策略地图",
  "azilect_strategy_map": "Azilect 策略地图",
  "expense_info_title": "费用信息",
  "delete_expense": "删除餐费",
  "expense_desc": "如本次拜访涉及餐费报销，<br />请在此添加餐费详情。",
  "add_expense": "添加餐费",
  "co_visit": "协访",
  "visit": "拜访",
  "create": "新建",
  "edit_btn": "编辑",
  "delete_btn": "删除",
  "visit_customer": "拜访客户",
  "visit_date": "拜访日期",
  "visit_time": "拜访时间",
  "visit_type": "拜访形式",
  "co_visit_colleague": "协访同事",
  "visit_goal": "拜访目标",
  "involved_product": "涉及产品",
  "visit_date_limit": "拜访日期不能早于7天前",
  "fill_key_message": "请选择关键信息",
  "expense_date_limit": "不能创建日期早于今天的餐费拜访",
  "expense_product_limit": "包含餐费的拜访必须选择至少一个产品",
  "expense_limit_300": "预计餐费不能超过人均300标准",
  "expense_limit_ytd": "预计餐费不能超过YTD餐费余额",
  "expense_product_proportion": "产品比例总和必须为100%",
  "save_success": "修改成功",
  "create_success": "创建成功",
  "delete_success": "删除成功",
  "delete_fail": "删除失败",
  "save_fail": "保存失败",
  "confirm_delete_record": "是否删除这条记录",
  "confirm_back": "当前内容未保存，是否确认返回？",
  "prompt_title": "提示",
  "morning": "上午",
  "afternoon": "下午",
  "full_day": "全天",
  "question_label": "问题",
  "input_feedback_placeholder": "输入反馈内容...",
  "voice_to_text_loading": "语音转文字中...",
  "ai_extracting": "AI正在提炼关键信息...",
  "default_suggestion": "请直接语音录入反馈，点击“+问题”可以关联特定主题。",
  "suggestion_prefix": "可以进一步追问：",
  "select_key_topic_title": "选择关键主题/问题",
  "no_key_questions": "暂无关键问题",
  "confirm_delete_feedback": "确定要删除这条反馈吗？",
  "ai_summary_failed": "AI总结生成失败",
  "ai_summary_failed_retry": "AI总结生成失败，请稍后重试",
  "ai_summary_generating": "AI正在生成总结...",
  "ai_summary_empty": "暂无可保存的总结内容",
  "ai_summary_api_missing": "未配置AI总结接口",
  "ai_visit_summary_title": "AI拜访总结",
  "add_related_question": "添加关联问题",
  "ai_summary_label": "AI智能总结",
  "original_feedback_label": "原始反馈",
  "speech_subtitle": "请自然描述拜访反馈",
  "key_feedback_question_type_single": "单选",
  "key_feedback_question_type_multiple": "多选",
  "key_feedback_question_type_voice": "语音",
  "filter_product_placeholder": "筛选产品",
  "filter_event_placeholder": "筛选任务",
  "no_more_task": "没有更多任务了",
  "meeting_time": "会议时间",
  "preview": "预览",
  "recommended_reason": "推荐理由",
  "mark": "标",
  "indicates": "表示",
  "invite": "邀请",
  "fill_in": "填报",
  "executed": "已执行",
  "ignored": "已忽略",
  "re_invite": "再邀请",
  "re_send": "再发送",
  "modify": "修改",
  "interaction_details": "互动详情",
  "browse": "浏览",
  "no_interaction_history": "暂无互动记录",
  "content_preview": "内容预览",
  "all_products": "全部产品",
  "all_tasks": "所有任务",
  "target_hcp": "目标医生",
  "priority_recommend": "优先推荐",
  "confirm_operation": "确认操作",
  "confirm_ignore_task": "确定要忽略该任务吗？",
  "confirm": "确定",
  "cancel": "取消",
  "ignore_task_failed": "忽略任务失败，请稍后再试",
  "execute_task_failed": "任务执行失败，请稍后再试",
  "recommended_script": "建议话术",
  "copy_script": "复制话术",
  "male": "男",
  "female": "女",
  "unknown": "未知",
  "ai_intro": "我是你的AI助手，可以帮你更高效地完成日常工作",
  "quick_workflow": "快捷工作流",
  "workflow_example": "💡 比如“帮我记录一个拜访”：",
  "workflow_guide_content": "告诉我拜访的<b>客户姓名</b>，<b>拜访时间</b>，如果已经拜访过了，告诉我完整的<b>医生反馈</b>。",
  "input_placeholder": "输入您的问题...",
  "call_strategy": "最佳行动建议",
  "nba_suggestions": "NBA行动建议",
  "suggested_nba": "以下是系统建议的行动",
  "no_recommended_nba": "暂无推荐行动",
  "suggested_visit": "以下是系统建议的拜访",
  "suggestion_position": "{current}/{total}",
  "no_recommended_visit": "暂无推荐拜访",
  "ask_ai_helper": "AI帮我准备拜访",
  "ask_ai_prepare_action": "问 AI 准备行动",
  "ask_ai_prepare_content": "问 AI 准备内容",
  "last_visit_prefix": "",
  "last_visit_suffix": "最近互动",
  "no_visit_record": "未查到互动记录",
  "over_days_no_visit": "超过{days}天未互动",
  "recommend_reason": "推荐理由：",
  "create_visit_plan": "创建拜访计划",
  "content_sent": "已发送过",
  "customer_overview": "客户要览",
  "visit_summary": "拜访总结",
  "recent_visit_summary": "近期拜访总结",
  "no_clear_feedback": "暂无明确反馈",
  "visited": "已拜访过",
  "not_suitable": "不适合",
  "reject_reason_recent_visit": "近期已拜访",
  "reject_reason_inconvenient": "客户不方便",
  "reject_reason_irrelevant": "话题不相关",
  "reject_reason_no_demand": "暂无需求",
  "reject_reason_other": "其它理由",
  "no_recommendation": "暂无推荐",
  "loading_strategy": "加载策略中...",
  "tab_workbench": "工作台",
  "tab_customer": "客户",
  "tab_visit": "拜访",
  "tab_task": "任务",
  "tab_live": "直播",
  "tab_content": "内容",
  "kpi_analysis_title": "KPI 概览",
  "total_achievement_rate": "整体完成率",
  "overall_achievement": "整体完成率",
  "completed_count": "完成数量",
  "target_count": "目标数量",
  "updated_at": "更新于",
  "statistics_as_of": "统计截止",
  "kpi_summary_desc": "数据来源于Super Rep系统，仅供业务过程参考，不代表正式考核及奖金计算结果。",
  "kpi_more_suggestions_cta": "获取更多KPI建议",
  "kpi_more_suggestions_desc": "带上当前结果前往AI助手继续追问",
  "view_all": "查看全部",
  "kpi_target_short": "目标",
  "kpi_weekly_target_short": "本周目标",
  "kpi_completion_rate": "完成率",
  "kpi_threshold_reached": "已达成门槛",
  "kpi_day_unit": "天",
  "kpi_calls_per_day_unit": "次/日",
  "kpi_period_current": "当前",
  "kpi_period_day": "日",
  "kpi_period_week": "周",
  "kpi_period_month": "月",
  "kpi_period_quarter": "季度",
  "kpi_section_customer_development": "客户发展",
  "kpi_section_academic_interaction": "学术互动",
  "kpi_section_digital_interaction": "数字化互动",
  "kpi_section_behavior_process": "行为与过程",
  "kpi_section_award_threshold": "获奖门槛",
  "kpi_target_customer_count": "目标客户数(去重)",
  "kpi_ab_customer_ratio": "A/B客户占比",
  "kpi_abc_customer_coverage": "A/B/C客户覆盖率",
  "kpi_abc_customer_monthly_coverage_frequency": "A/B/C客户月覆盖频次",
  "kpi_target_customer_bind_rate": "目标客户绑定率",
  "kpi_quarterly_meetings": "季度会议场次",
  "kpi_quarterly_sign_in_rate": "季度电子签到率",
  "kpi_quarterly_content_push": "季度数字化内容推送",
  "kpi_questionnaire_completion_rate": "问卷完成率",
  "kpi_kol_content_push": "KOL内容推送",
  "kpi_monthly_working_days": "月工作天数",
  "kpi_visit_plan_count": "拜访计划次数",
  "kpi_plan_achievement_rate": "计划达成率",
  "kpi_abc_customer_dedup_count": "ABC客户去重数量",
  "kpi_daily_face_to_face_calls": "日均面对面拜访",
  "kpi_visit_count": "拜访数量",
  "kpi_new_user_expansion": "新用户拓展",
  "kpi_meeting_coverage": "会议覆盖",
  "kpi_academic_promotion": "学术推广",
  "kpi_visit_coverage": "拜访覆盖",
  "kpi_task_execution": "任务执行",
  "kpi_deal_progression": "缔结推进",
  "perception_action_suggestions": "行动建议",
  "perception_online_tasks": "线上任务",
  "perception_no_tasks": "暂无任务",
  "wechat_bind_status_title": "微信绑定状态",
  "wechat_bind_label": "微信绑定：",
  "wechat_bind_pending_unbind": "申请解除绑定",
  "wechat_bind_approve_unbind": "批准解除",
  "wechat_bind_bound": "已绑定",
  "wechat_bind_date_suffix": "绑定",
  "wechat_bind_unbind_action": "解除绑定",
  "wechat_bind_unbound": "未绑定",
  "wechat_consent_label": "知情同意：",
  "wechat_consent_pending_cancel": "申请取消签署",
  "wechat_consent_approve_cancel": "批准取消",
  "wechat_consent_signed": "已签署",
  "wechat_consent_date_suffix": "签署",
  "wechat_consent_cancel_action": "取消签署",
  "wechat_consent_unsigned": "未签署",
  "wechat_content_sent": "内容发送：",
  "wechat_content_opened": "内容打开：",
  "wechat_interaction_history_title": "线上互动历史",
  "wechat_history_open": "打开",
  "wechat_history_sent": "发送",
  "wechat_history_viewed": "浏览",
  "wechat_unbind_dialog_title": "解除绑定",
  "wechat_unbind_dialog_message_line1": "请确认您是否要解除绑定该医生与已绑定微信的关联？",
  "wechat_unbind_dialog_message_line2": "解除绑定操作不能恢复，需要重新向该医生发送内容并通过微信好友转发，医生打开确认后，将再次绑定。",
  "wechat_unsign_dialog_title": "取消签署",
  "wechat_unsign_dialog_message": "请确认您是否要取消签署该医生的知情同意？",
  "wechat_duration_hour": "小时",
  "wechat_duration_minute": "分",
  "wechat_duration_second": "秒",
  "wechat_notify_unbind_type": "微信解绑",
  "wechat_notify_unsign_type": "取消签署知情同意",
  "wechat_notify_message_title": "[申请{type}] {user}",
  "wechat_notify_message_content": "您的同事{user}申请为{institution}专家{physician}{type}。请点击<a href='{url}'>此处</a>进行进一步操作。",
  "smart_summary": "智能摘要",
  "refresh": "刷新",
  "detailed_analysis": "详细分析",
  "no_detail_content": "暂无详情内容",
  "further_understanding": "进一步了解",
  "ask_something_else": "我想问点别的...",
  "follow_up_q1": "有哪些客户需要优先安排拜访？",
  "follow_up_q2": "最近一个月有没有什么重要外部事件？",
  "follow_up_q3": "我该如何调整下个月拜访节奏？",
  "based_on_recent_updates": "基于近期动态，",
  "clinical_doctor": "临床医生",
  "he_expert": "卫经专家",
  "click_to_search_filter": "点击进行搜索和筛选",
  "filter": "筛选",
  "no_clinical_doctor": "暂无临床医生",
  "no_he_expert": "暂无卫经专家",
  "hcp_home_doctor_list_tab": "医生列表",
  "hcp_home_hospital_list_tab": "医院列表",
  "hcp_hospital_list_search_placeholder": "输入医院搜索",
  "hcp_hospital_list_search_button": "搜索",
  "hcp_hospital_list_count": "医院数：",
  "hcp_hospital_list_search_desc": "可输入医院名称进行搜索",
  "kol_list_search_placeholder": "输入医院/科室/医生搜索",
  "kol_list_questionnaire_completed": "问卷已填写",
  "kol_list_questionnaire_pending": "问卷未填写",
  "kol_list_questionnaire_completion_rate": "问卷完成度",
  "doctor_count": "医生数：",
  "search_desc_title": "搜索说明",
  "search_desc_content": "可输入医院名称、科室名称和医生姓名，以及选择产品和医生分型进行搜索",
  "sort_desc_title": "排序说明",
  "sort_by_name": "按姓名：",
  "sort_by_name_desc": "按照医生姓名的汉语拼音顺序排序",
  "sort_by_hospital": "按医院名称：",
  "sort_by_hospital_desc": "按照医院名称的汉语拼音顺序排序",
  "sort_by_level": "按医生等级：",
  "sort_by_level_desc": "按照医生的ABC等级排序（仅支持在选择了产品搜索时使用）",
  "hcp_list_default_sort": "默认：",
  "hcp_list_default_sort_desc": "按照是否关注、医生姓名的汉语拼音顺序排序",
  "hcp_list_default_sort_option": "默认排序",
  "hcp_list_sort_by_hospital_option": "按医院排序",
  "search_keyword": "搜索关键词",
  "enter_keyword": "请输入关键词",
  "hcp_list_is_target_doctor": "是否目标医生",
  "hcp_list_segment": "观念分型",
  "hcp_list_sales_class": "销售分级",
  "is_favorite": "是否关注",
  "is_covered": "是否覆盖过",
  "is_wechat_bound": "是否微信绑定",
  "is_consent_signed": "是否已签署知情同意",
  "back": "返回",
  "reset": "重置",
  "hcp_list_all_customers": "我的全部客户",
  "hcp_list_wechat_doctor_count": "微信绑定医生：",
  "hcp_list_target": "目标",
  "hcp_list_non_target": "非目标",
  "hcp_list_class_suffix": "级",
  "hcp_list_bound": "已绑定",
  "hcp_list_unbound": "未绑定",
  "hcp_list_consented": "已知情",
  "hcp_list_not_consented": "未知情",
  "hcp_list_filter_prompt_prefix": "：",
  "hcp_list_filter_prompt_separator": "，",
  "hcp_list_segment_waiter": "观望者",
  "hcp_list_segment_trier": "尝试者",
  "hcp_list_segment_advocate": "倡导者",
  "all_segments": "全部分型",
  "favorite": "已关注",
  "not_favorite": "未关注",
  "covered": "已覆盖",
  "not_covered": "未覆盖",
  "wechat_bound": "已绑定微信",
  "wechat_not_bound": "未绑定微信",
  "consent_signed": "已签署同意",
  "consent_not_signed": "未签署同意",
  "today": "今天",
  "tomorrow": "明天",
  "no_co_visit": "暂无协访",
  "visit_history": "拜访记录",
  "no_visit": "暂无拜访",
  "no_visit_data": "暂无拜访数据",
  "no_co_visit_today": "今天暂无协访",
  "no_visit_today": "今天暂无拜访",
  "new_action": "新建",
  "year": "年",
  "back_doctor_list": "返回医生列表",
  "strategy_map": "策略地图",
  "customer_persona": "客户画像",
  "basic_info": "基本信息",
  "latest_news": "最新动态",
  "academic_details": "学术详情",
  "timeline_show_legend": "类型说明",
  "timeline_hide_legend": "收起说明",
  "timeline_legend_internal": "内部交互",
  "timeline_legend_online": "线上互动",
  "timeline_legend_external": "外部动态",
  "timeline_legend_academic": "学术活动",
  "timeline_expand": "展开",
  "timeline_collapse": "收起",
  "timeline_detail": "详细",
  "timeline_unknown_date": "未知",
  "timeline_read_duration": "阅读{duration}",
  "timeline_platform_sent": "发送",
  "timeline_content_send_title": "内容发送",
  "timeline_content_open_title": "内容打开",
  "timeline_type_mr_call": "销售拜访",
  "timeline_type_msl_call": "医学拜访",
  "timeline_type_internal_meeting": "内部会议",
  "timeline_type_msl_insight": "医学洞见",
  "timeline_type_content_send": "文章发送",
  "timeline_type_content_open": "文章打开",
  "timeline_type_wechat_article": "公众号",
  "timeline_type_patient_article": "患教文章",
  "timeline_type_patient_live": "患教直播",
  "timeline_type_third_party_meeting": "第三方会议",
  "timeline_type_publication": "论文发表",
  "timeline_type_clinical_trial": "临床试验",
  "timeline_type_national_fund": "国自然基金",
  "timeline_type_award": "获奖",
  "timeline_type_guideline": "指南共识",
  "timeline_type_patent": "专利发明",
  "timeline_purpose_delivering_product_message": "传递产品信息",
  "timeline_purpose_information_collection": "信息收集",
  "timeline_purpose_meeting_follow_up": "会议邀请/跟进",
  "timeline_purpose_reminding": "提醒",
  "timeline_purpose_nrdl": "医保目录(NRDL)",
  "timeline_purpose_others": "其他",
  "timeline_purpose_mkt_activity": "市场活动",
  "timeline_purpose_positive": "积极回应",
  "details_tab_persona": "画像",
  "details_tab_strategy": "策略",
  "details_tab_basics": "基础",
  "details_tab_news": "动态",
  "details_tab_academic": "学术",
  "details_tab_wechat": "微信",
  "day": "日",
  "ai_summary_title": "AI要点速览",
  "ai_nba_suggestions_title": "AI行动建议（NBA）",
  "ai_nba_reason_label": "推荐理由：",
  "ai_nba_detail_label": "建议详情：",
  "ai_nba_next_step_label": "下一步：",
  "ai_nba_default_title": "下一步行动建议",
  "ai_nba_action_type_call": "拜访建议",
  "ai_nba_action_type_meeting": "会议",
  "ai_nba_action_type_content": "内容",
  "ai_nba_action_type_content_push": "推文建议",
  "ai_nba_action_type_meeting_invite": "会议邀请",
  "ai_nba_action_type_meeting_speaker": "讲者机会",
  "ai_nba_action_type_default": "建议",
  "ai_nba_trigger_type_coverage_gap": "覆盖缺口",
  "ai_nba_trigger_type_positive_feedback": "积极反馈",
  "ai_nba_trigger_type_objection_followup": "异议跟进",
  "ai_nba_trigger_type_digital_engagement": "数字互动",
  "ai_nba_trigger_type_content_interest": "内容兴趣",
  "ai_nba_trigger_type_meeting_opportunity": "会议机会",
  "ai_nba_trigger_type_doctor_dynamic": "医生动态",
  "ai_nba_trigger_type_sales_trend": "销量趋势",
  "ai_interaction_summary": "AI互动总结",
  "ai_action_plan_title": "AI Next-Best-Actions",
  "ai_action_plan_follow_up": "进一步了解行动计划",
  "ai_action_plan_create_visit": "创建拜访",
  "ai_action_plan_create_meeting": "创建科室会",
  "ai_action_plan_create_regional_meeting": "创建区域会",
  "ai_action_plan_default_doctor": "该医生",
  "ai_action_plan_item_1_title": "1 关注医院销量变化",
  "ai_action_plan_item_1_desc": "系统监测到巴黎医生所在医院近期心达悦销量连续下降，建议优先确认院内进药及库存状态。",
  "ai_action_plan_item_2_title": "2 讲者推荐评估",
  "ai_action_plan_item_2_desc": "系统影响力关系网络分析显示，巴黎医生目前覆盖约18位相关科室医生，在院内具有一定影响力，具备潜在讲者基础。\n建议优先考虑其参与科室学术分享或病例讨论，逐步培养为院内讲者。\n推荐分享话题：抑郁伴焦虑患者的临床识别与治疗策略",
  "ai_action_plan_item_3_title": "3 建议开展科室学术活动",
  "ai_action_plan_item_3_desc": "建议通过科室会 / 院内会加强巴黎医生对心达悦的接受度。\n根据医生影响力关系网络分析，推荐同科室 卜碧涛主任医师 作为讲者。",
  "ai_action_plan_item_4_title": "4 推进医生观念认知提升",
  "ai_action_plan_item_4_desc": "当前系统评估巴黎医生的产品观念阶段为“尝试者”，且该阶段已维持较长时间，建议在本次拜访中再次传递相关临床证据材料《抑郁伴焦虑的临床诊疗现状与优化策略》，评估医生当前认知是否发生变化。",
  "ai_action_plan_caojie_stage_1_title": "建议拜访，获取院内最新诊疗与用药动态",
  "ai_action_plan_caojie_stage_1_desc": "系统捕捉到院内近期存在相关学术或诊疗动态，医生可能存在认知更新窗口",
  "ai_action_plan_caojie_stage_2_title": "跟进拜访，进一步深入了解住院患者使用经验",
  "ai_action_plan_caojie_stage_2_desc": "上次沟通中医生已提及在住院患者中存在初步使用，具备进一步挖掘临床反馈的价值",
  "ai_action_plan_caojie_stage_2_desc_prefix": "上次沟通",
  "ai_action_plan_caojie_stage_2_desc_suffix": "中，医生已提及在住院患者中存在初步使用，具备进一步挖掘临床反馈的价值",
  "ai_action_plan_caojie_stage_3_title": "建议担任区域学术会议讲者，分享真实临床使用经验",
  "ai_action_plan_caojie_stage_3_desc": "医生已形成正向临床反馈，具备真实世界经验与学术影响力，适合进行学术传播转化",
  "ai_action_plan_caojie_extra_visit_title": "建议本次拜访再次传递临床证据，推进观念认知提升",
  "ai_action_plan_caojie_extra_visit_desc": "当前系统评估曹杰医生的产品观念阶段为“尝试者”，且该阶段已维持较长时间，建议在本次拜访中再次传递相关临床证据材料《抑郁伴焦虑的临床诊疗现状与优化策略》，评估医生当前认知是否发生变化。",
  "ai_action_plan_previous_visit_button": "Call {date}",
  "ai_action_plan_create_meeting_prompt": "我想要创建一个{name}（医生ID：{physicianId}）所在科室的科室会，会议主题是提升对心达悦的接受度，推荐讲者是卜碧涛。",
  "ai_action_plan_create_regional_meeting_prompt": "我想为{name}（医生ID：{physicianId}）创建一个区域学术会，目标是分享真实临床使用经验并推动学术传播转化。",
  "ai_action_plan_follow_up_prompt": "我想了解{name}（医生ID：{physicianId}）的下一步行动建议",
  "no_feedback_summary": "暂无相关的拜访反馈总结",
  "further_inquiry_suggestions": "进一步探询建议",
  "input_further_question": "请输入进一步问题…",
  "other": "其他",
  "risk": "风险",
  "barrier": "阻碍",
  "difficulty": "难点",
  "opportunity": "机会",
  "advantage": "优势",
  "hospital_info": "医院信息",
  "nmpa_details": "NMPA详情",
  "profile_professional_title": "职称",
  "profile_admin_title": "行政职务",
  "profile_academic_title": "教学职务",
  "profile_social_roles": "社会任职",
  "office_tier_international": "国际级",
  "office_tier_national": "国家级",
  "office_tier_provincial": "省级",
  "office_tier_municipal": "市级",
  "profile_key_customer_top": "重点",
  "profile_key_customer_bottom": "客户",
  "kol_speaker_details": "KOL/讲者详情",
  "national_level": "全国级",
  "city_level": "城市级",
  "city_region_level_txt": "城市级/区域级",
  "hospital_level": "医院级",
  "national_kol": "国家级",
  "regional_kol": "区域级",
  "level_kol": "KOL",
  "level_speaker": "讲者",
  "no_explicit_feedback": "暂无明确反馈",
  "no_feedback": "暂无反馈",
  "based_on_doctor_feedback": "基于{institution}{name}老师的近期反馈，请进一步分析：{question}",
  "based_on_doctor": "基于该医生的近期反馈，请进一步分析：{question}",
  "recent_visit_feedback_q": "近期拜访反馈，{question}",
  "generated_by_ai": "由 AI 总结生成",
  "voice_input": "语音输入",
  "stop_recording": "停止录音",
  "ai_listening": "AI 正在倾听",
  "speak_question": "请说出您的问题...",
  "max_60_seconds": "最多60秒",
  "end_recording": "结束录音",
  "next_action_suggestions": "下一步行动建议",
  "quarterly_promotion_progress": "本季度推广进度",
  "view_details": "查看详情",
  "deadline": "季度截止",
  "completed_forwards": "已完成转发",
  "quarterly_target_forwards": "本季度目标转发",
  "open": "打开",
  "refresh_batch": "重新评估",
  "refresh_ai_confirm_title": "确认重新评估建议",
  "refresh_ai_confirm_message": "是否要让 AI 重新评估当前建议？此操作可能会耗时1分钟以上。",
  ...gbaAdminExtra
}
